import {RouterModule, Routes} from '@angular/router';

const appRoutes: Routes = [
  { path: '**', redirectTo: '/realtime?panel=live'}
];

export const Routing = RouterModule.forRoot(appRoutes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts